import React, { Component } from 'react';
// import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

const INITIAL_FORM_STATE = {
  trackerKey: 'bysat',
  trackerSurrogate: '',
  trackerType: 'bysat',
  startTrackingTime: '',
};

class ModalFormVehicleTrackerActivate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: INITIAL_FORM_STATE,
    };

    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleModalAccept = this.handleModalAccept.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleModalClose() {
    this.props.onCancel();
  }

  handleModalAccept(ev) {
    ev.preventDefault();

    this.props.onAccept({ ...this.state.form }, this.props.vehicle.$key);
    this.setState({
      form: INITIAL_FORM_STATE,
    });
  }

  handleInputChange(ev) {
    const { name, value } = ev.target;

    this.setState({
      form: {
        ...this.state.form,
        [name]: value,
      },
    });
  }

  render() {
    return (
      <Modal show={this.props.showModal} onHide={this.handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Ativação de Rastreamento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Rastreador do Veículo - {this.props.vehicle.plate}</h3>

          <form onSubmit={this.handleModalAccept}>
            <div className="form-group">
              <label htmlFor="trackerType">Empresa de Rastreamento</label>
              <select
                className="form-control"
                name="trackerType"
                value={this.state.form.trackerType}
                onChange={this.handleInputChange}
                disabled
              >
                <option value="bysat">BySat</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="trackerKey">Rastreador</label>
              <select
                className="form-control"
                name="trackerKey"
                value={this.state.form.trackerKey}
                onChange={this.handleInputChange}
                disabled
              >
                <option value="bysat">BySat</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="trackerSurrogate">Código de Integração do Veículo</label>
              <input
                type="text"
                className="form-control"
                name="trackerSurrogate"
                value={this.state.form.trackerSurrogate}
                onChange={this.handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="startTrackingTime">Data de Início da Integração</label>
              <input
                type="datetime-local"
                className="form-control"
                name="startTrackingTime"
                value={this.state.form.startTrackingTime}
                onChange={this.handleInputChange}
              />
            </div>

            {/* <div className="form-group">
              <label htmlFor="fleet">Frota</label>
              <select
                className="form-control"
                name="fleet"
                value={this.state.vehicle.fleet}
                onChange={this.handleInputChange}
              >
                {_.map(this.props.fleets, (fleet, key) => (
                  <option key={key} value={key}>{fleet.name}</option>
                ))}
                <option value="">Nenhuma</option>
              </select>
              // aria-describedby="fleetHelp"
              // <small id="fleetHelp" className="form-text text-muted">
              // A operação selecionad</small>
            </div> */}

            <button type="submit" hidden />
          </form>

        </Modal.Body>
        <Modal.Footer>
          <a
            className="button"
            onClick={this.handleModalClose}
            onKeyPress={this.handleModalClose}
            role="button"
            tabIndex={0}
          >
            Cancelar
          </a>
          <a
            className="button"
            onClick={this.handleModalAccept}
            onKeyPress={this.handleModalAccept}
            role="button"
            tabIndex={0}
          >
            Confirmar
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}

ModalFormVehicleTrackerActivate.propTypes = {
  vehicle: PropTypes.object.isRequired,
  // vehicle: PropTypes.shape({
  //   $key: PropTypes.string,
  //   plate: PropTypes.string,
  //   fleet: PropTypes.string,
  // }).isRequired,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  // TODO: trackers: PropTypes.object.isRequired,
};

// TODO: load trackers from client options
// export default connect(store => ({
//   fleets: store.fleetState.fleets || {},
// }))(ModalFormVehicleTrackerActivate);

export default ModalFormVehicleTrackerActivate;



// WEBPACK FOOTER //
// ./src/Vehicle/ModalFormVehicleTracker.js